import React from "react";

function GoogleMap() {
    return (
        <div className="map-responsive" style={{ overflow: 'hidden', paddingBottom: '56.25%', position: 'relative', height: 0 }}>
            <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2019.325394244048!2d17.384899500865064!3d44.14774203907406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475fafd2cd09043b%3A0x569b767420d7da01!2sDonji%20Vakuf!5e1!3m2!1sen!2sba!4v1746129210855!5m2!1sen!2sba"
                width="100%"
                height="100%"
                style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
}

export default GoogleMap;
